import React from 'react';
import receevitBlueTransparent from '../../assets/logos/receevit-blue-transparent.png';
import receevitWhiteTransparent from '../../assets/logos/receevit-white-transparent.png';

// Logo component using transparent variants for better visibility

const ReceevitLogo = ({ 
  width = 160, 
  height = 54, 
  className = '',
  forBlueBackground = false
}) => {
  // Blue logo for white backgrounds, white logo for blue backgrounds
  const logoSrc = forBlueBackground ? receevitWhiteTransparent : receevitBlueTransparent;
  
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src={logoSrc} 
        alt="Receevit®" 
        width={width} 
        height={height}
        className="flex-shrink-0"
      />
    </div>
  );
};

// Compact version for smaller spaces
export const ReceevitLogoCompact = ({ 
  size = 160, 
  className = '',
  forBlueBackground = false
}) => {
  // Blue logo for white backgrounds, white logo for blue backgrounds
  const logoSrc = forBlueBackground ? receevitWhiteTransparent : receevitBlueTransparent;
  
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img 
        src={logoSrc} 
        alt="Receevit®" 
        width={size} 
        height={size}
        className="object-contain"
      />
    </div>
  );
};

export default ReceevitLogo;
